 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		391: 0,
 		277: 0,
 		278: 0,
 		281: 0,
 		283: 0,
 		284: 0,
 		286: 0,
 		287: 0,
 		288: 0,
 		341: 0,
 		342: 0,
 		348: 0,
 		349: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","215":"AddClosedAlertIDUseCase","216":"CreateDeviceUseCase","217":"CreateDomestikaFollowUseCase","218":"CreateJWTUserUseCase","219":"CreateUserLiveSessionUseCase","220":"CurrentUserUseCase","221":"CurrentWithoutRelationshipsUserUseCase","222":"DeleteDeviceUseCase","223":"DeleteFollowUseCase","224":"ENV_CONFIG1","225":"ENV_CONFIG4","226":"ENV_CONFIG5","227":"ENV_CONFIG6","228":"ENV_CONFIG7","229":"FinishUserLiveSessionUseCase","230":"GetAccessTokenUserUseCase","231":"GetAdvanceGDPRStatusUserUseCase","232":"GetAllBlogUseCase","233":"GetAreasCourseUseCase","234":"GetCartCourseUseCase","235":"GetCategoriesCourseUseCase","236":"GetCourseUseCase","237":"GetFinalProjectVideoByCourseIDCourseUseCase","238":"GetGDPRStatusUserUseCase","239":"GetListLiveFeedbackQuestionUseCase","240":"GetListLiveSessionUseCase","241":"GetListLiveStreamUseCase","242":"GetLiveChannelUseCase","243":"GetLiveSessionUseCase","244":"GetOrganizationUseCase","245":"GetPlusPromotionUseCase","246":"GetPostContentBlogUseCase","247":"GetPromotionCodeAlertUseCase","248":"GetPromotionUseCase","249":"GetPubnubCredentialsUseCase","250":"GetSessionDataUserUseCase","251":"GetSimpleUserUseCase","252":"GetSoftwaresCourseUseCase","253":"GetUserAlertUseCase","254":"GetVideoProgressListCourseUseCase","255":"GetVideoSpeedUserUseCase","256":"GetVideoVolumeUserUseCase","257":"LogoutUserUseCase","258":"PathToRegexp","259":"RefreshAccessTokenUserUseCase","260":"RemoveAccessTokenUserUseCase","261":"SearchCourseUseCase","262":"SendHeaderTrackingUseCase","263":"SendLiveFeedbackAnswersUseCase","264":"SendPlayerTrackingUseCase","265":"SendTrackingUseCase","266":"SendVideoProgressCourseUseCase","267":"SetAdvanceGDPRStatusUserUseCase","268":"SetGDPRStatusUserUseCase","269":"SetVideoSpeedUserUseCase","270":"SetVideoVolumeUserUseCase","271":"UpdateLanguageUserUseCase","272":"UpdateLiveSessionUseCase","273":"UpdateVideoAudioAndSubtitlesCourseUseCase","274":"UpdateVideoProgressCourseUseCase","275":"ViewPageTrackingUseCase","347":"vendors~AddClosedAlertIDUseCase","348":"vendors~AlgoliaSearch","349":"vendors~AmplitudeJS","350":"vendors~SearchCourseUseCase","351":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"61ced89b46d91ee4d0e9","1":"f0589ff0147f26cbd915","2":"2f2cd4aad12fe36909e9","3":"3d917faa60e4fc063e74","4":"5cf0c58ea7d3fbdcf796","5":"84fb6fa09f1eebd3de3e","215":"fe27b1ed9d8b0873d5d8","216":"526c262282444ef29e23","217":"1039199329a324b80a59","218":"cb102d32cc1b440ca150","219":"849ab678791a7f9954a6","220":"f6f49cce7ca430f6eb4e","221":"fe70fdd47af9d9595e99","222":"d749771a8845681ae631","223":"4049be03a22bb0809b5c","224":"83b14695d0286720da67","225":"798ffce9ba2f45696e7a","226":"5e2fffc8695524724102","227":"9d0595f0d6ddbfeaa381","228":"41fb686647f6e7db764c","229":"581157b98b1ddd4494e2","230":"dc425655b79f028fdb90","231":"4ffe4679975ffaa84b4b","232":"8ee955aa018606657433","233":"5e3dacd39016549b670d","234":"9595b135a8589356d691","235":"db3e4884782685fcca31","236":"eb776cffc4549c94e26d","237":"ecd767629eb768ed0c0d","238":"f4cc87622628703562f7","239":"9498968f7a745f543086","240":"8a038d8a7c40bf3a3df9","241":"872b09bb08399cdce9cb","242":"406e07d9e8c3be510d5c","243":"346150fef354abe2d18c","244":"dffec4cb2d587b71f4e1","245":"7b4ce6185db0a68ab076","246":"9bc2b093bacb436fb334","247":"c223c4be0edaf7611ac4","248":"e611343c74f5c489cc83","249":"e808cbc8ece520dcac01","250":"c153178f608e59096e63","251":"867e29f3615ca51a792e","252":"aa77ec307449d22eede6","253":"ed49b4b3a94f6c66bad7","254":"aa93692b29187c8420eb","255":"bc3db372dd5f18101f4c","256":"ee2b0a4921b6f41420c5","257":"cbf6623e0c0e3640ad2d","258":"779df52acaad7401ebc1","259":"02b98c328f95ae922389","260":"c88ae1b774b4f4a11583","261":"4b798873434282cb02bc","262":"0e54aac798b2623187ef","263":"42301966aaeb432b0b77","264":"912316464a996ccd4439","265":"77090e442df35398218f","266":"8da3c09da4de04d7c461","267":"010ca3071521e42bd327","268":"85a485000166a60ef4b6","269":"33b93053837b22b7657b","270":"8b89eaf5d47518de5630","271":"e7286a1ec411d5461a4f","272":"1c7764d6cb558035e2b0","273":"6b9812d0170e2e089c0a","274":"b58a283142aff0c95b0a","275":"0b43e4821a79cc3165f7","347":"ab12a6d916717d37252c","348":"23596eaa187eb8308c80","349":"3f95a73d9434c55ef0a9","350":"2cfa8e651ded2247c7a5","351":"33943379827ce844f646","426":"2308325eaa2609bef5fd","644":"575f3f81e10cb3801188","645":"d99c755ffe903ee35bdc","646":"d71d8567a525acf81a84"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.domestika.org/raw/upload/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2349);
